import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=e19b24a4&scoped=true"
import script from "./privacy_policy.vue?vue&type=script&lang=js"
export * from "./privacy_policy.vue?vue&type=script&lang=js"
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=e19b24a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19b24a4",
  null
  
)

export default component.exports